import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'lib/utility/i18n';
import { getLocaleVersion, isIncentiveActive } from '../common/functions';
import { Core, Button, IconCategoryValue } from 'reactifi';

export default class CoreSharedCard extends React.Component {
  static propTypes = {
    cardType: PropTypes.string.isRequired,
    destinationUrl: PropTypes.string.isRequired,
    genericIncentive: PropTypes.object,
    incentive: PropTypes.shape({
      archived: PropTypes.bool,
      claim_message: PropTypes.string,
      incentive_activity: PropTypes.shape({
        status: PropTypes.string
      }),
      incentive_message: PropTypes.string
    }),
    program: PropTypes.shape({
      remove_content_images: PropTypes.bool,
      slug: PropTypes.string.isRequired
    }),
    iconUrl: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    learnerDashboard: PropTypes.bool,
    name: PropTypes.string.isRequired
  }

  incentiveMessage = () => {
    const { genericIncentive, incentive } = this.props;

    if (isIncentiveActive(incentive)) {
      const { claim_message, incentive_activity = {}, incentive_message } = incentive;
      const incentiveComplete = incentive_activity.status === 'completed';
      return incentiveComplete ? claim_message : incentive_message;
    } else if (genericIncentive && !genericIncentive.archived) {
      return i18n.t('Incentive Available!');
    } else {
      return null;
    }
  }

  render() {
    const {
      cardType,
      destinationUrl,
      id,
      iconUrl,
      learnerDashboard,
      name,
      program
    } = this.props;
    const incentiveMessage = this.incentiveMessage();
    
    return (
      <>
        <Core.Card size="sm" minH={200} data-object-type="playlists" data-object-id={id}>
          <Core.CardBody paddingTop={'md'}>
            <Core.Layout variant="stack" direction={{ base: 'column', sm: 'row' }}>
              <Core.Layout variant="stack" flex="1" order={{ base: '2', sm: 'unset' }} gap={0}>
                <Core.Typography id={`card-header-${id}`} textStyle={`${!learnerDashboard ? 'h3' : 'h2'}`}>{getLocaleVersion(this.props, 'name')}</Core.Typography>
                <Core.Typography id={`card-description-${id}`} style={{ margin: 0 }}>{getLocaleVersion(this.props, 'tagline')}</Core.Typography>
              </Core.Layout>
              {!program.remove_content_images && <Core.Layout boxSize="16" mx="auto">
                <Core.Image id={`${cardType}-${id}`} path={iconUrl} aspectRatio={1 / 1} />
              </Core.Layout>
              }
            </Core.Layout>
          </Core.CardBody>
          <Core.CardFooter variant="flex" justifyContent="space-between" alignItems="center">
            <Core.Layout variant="stack" flex="1" order={{ base: '2', sm: 'unset' }} gap={0}>
              {!!incentiveMessage && <IconCategoryValue icon="star" value={incentiveMessage} />}
            </Core.Layout>
            <Core.Layout>
              <Button
                variant={'outline'}
                label={i18n.t('Explore')}
                style="secondary"
                colorScheme="brand"
                href={destinationUrl}
                data-action="explore-playlist"
                aria-label="Explore Playlist"
                rightIcon={"arrow-right"}
                id={`landing_page-playlist_button-${name}-${id}`}
                data-no-turbolink="true"
              />
            </Core.Layout>
          </Core.CardFooter>
        </Core.Card>
      </>
    )
  }
}
